import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { 
  UNSAFE_NavigationContext as NavigationContext
} from 'react-router-dom';
import AppRoutes from './routes';
import './App.css';

// 配置 React Router future flags
const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

function App() {
    return (
        <Router future={router.future}>
            <AppRoutes />
        </Router>
    );
}

export default App;